<!-- <div>
<i nz-icon nzType="folder" nzTheme="twotone" class="header-icon"></i>&nbsp;<b class="header-label">Create Page</b>
</div> -->
<pg-header
  title="Create Page"
  ticon="folder"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div style="text-align: right">
    <!-- <span nz-tooltip nzTooltipTitle="Create new page group" nzTooltipPlacement="bottom"> -->
    <button nz-button nzType="primary" (click)="createNwgrp()">
      <i nz-icon nzType="plus"></i>Create New Group
    </button>
    <!-- </span> -->
  </div>
  <nz-drawer
    [nzBodyStyle]="{ overflow: 'auto' }"
    [nzMaskClosable]="true"
    [nzWidth]="370"
    [nzVisible]="visible"
    nzTitle="Create new page"
    (nzOnClose)="close()"
  >
    <form nz-form [formGroup]="validateForm">
      <!-- <nz-form-item>
      <nz-form-label [nzSpan]="8">Page Group Name</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <input formControlName="pge_grp_nm" nz-input placeholder="please enter user name" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="8">Description</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <textarea formControlName="pge_grp_dscn_tx" nz-input placeholder="please enter page description"></textarea>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="8">Select Profile</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <nz-select
          [nzMaxTagCount]="3"
          [nzMaxTagPlaceholder]="tagPlaceHolder"
          nzMode="multiple"
          nzPlaceHolder="Please select" formControlName="prfle_id"
          >
          <nz-option *ngFor="let a of appPrfls" [nzLabel]="a.prfle_nm" [nzValue]="a.prfle_id"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item> -->
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <nz-form-item>
            <nz-form-control>
              <div class="inptLbl">Page Group Name</div>
              <input
                formControlName="pge_grp_nm"
                nz-input
                placeholder="please enter user name"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <nz-form-item>
            <nz-form-control>
              <div class="inptLbl">Description</div>
              <textarea
                formControlName="pge_grp_dscn_tx"
                nz-input
                placeholder="please enter page description"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <div class="inptLbl">Select Profile</div>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                [nzMaxTagCount]="3"
                [nzMaxTagPlaceholder]="tagPlaceHolder"
                nzMode="multiple"
                nzPlaceHolder="Please select"
                formControlName="prfle_id"
              >
                @for (a of appPrfls; track a) {
                <nz-option
                  [nzLabel]="a.prfle_nm"
                  [nzValue]="a.prfle_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <ng-template #tagPlaceHolder let-selectedList>
        and {{ selectedList.length }} more selected
      </ng-template>
      <div style="float: right">
        <button nz-button style="margin-right: 8px" (click)="close()">
          Cancel
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="submit()"
          [disabled]="!validateForm.valid"
        >
          Submit
        </button>
      </div>
    </form>
  </nz-drawer>
  <div class="m-24">
    <div>
      <div>
        <div class="input-row" nz-row>
          <div nz-col nzXs="12" nzSm="12" nzMd="6" nzLg="6" nzXl="11">
            <div class="inptLbl">Page Groups</div>
            <nz-select
              required
              [(ngModel)]="selectedGroupId"
              (ngModelChange)="onPgeGrpSelection()"
            >
              @for (pg of pagesLst; track pg) {
              <nz-option [nzValue]="pg.pge_grp_id" [nzLabel]="pg.pge_grp_nm">
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
      </div>
    </div>
    @if ((permissions.slct_in==1)?true:false) {
    <div nz-row class="gridTop">
      @if (loader) {
      <ds-loading></ds-loading>
      }
      <div class="ds-card grid">
        <app-data-grid
          id="gridContainer"
          class="p-8"
          style="width: 100%"
          [dataSource]="rowData"
          [legacyColumns]="columnDefs"
          [searchPanel]="true"
          [filterRow]="true"
          [filterPanel]="true"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
          exportFileName="Change Log"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          (cellClick)="onCellClick($event)"
          [cellPrepared]="bound_onCellPrepared"
        >
          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
            type="buttons"
            [width]="100"
            caption="Edit"
            cellTemplate="editTemplate"
          ></app-grid-column>
          <ng-template appGridCell="editTemplate" let-data="cell"
            ><div>
              <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
            </div></ng-template
          >
          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
            type="buttons"
            [width]="100"
            caption="Delete"
            cellTemplate="delTemplate"
          ></app-grid-column>
          <ng-template appGridCell="delTemplate" let-data="cell"
            ><div>
              <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
    }
    <nz-drawer
      [nzBodyStyle]="{
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        'padding-bottom': '53px'
      }"
      [nzMaskClosable]="false"
      [nzWidth]="370"
      [nzVisible]="shwSidebar"
      [nzTitle]="heading"
      (nzOnClose)="closeSideBar()"
    >
      <form nz-form [formGroup]="validatepgaeForm">
        <!-- <nz-form-item>
      <nz-form-label [nzSpan]="8">Page Name</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <input formControlName="pge_nm" nz-input placeholder="please enter page name" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="8">Page Url</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <input formControlName="pge_url_tx" nz-input placeholder="please enter page url" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="8">Page Description</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <textarea formControlName="pge_dscn_tx" nz-input placeholder="please enter page description"></textarea>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="8">Select Page Group</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <nz-select required nzPlaceHolder="Select Type" formControlName="pge_grp_id">
          <nz-option *ngFor="let pg of pagesLst" [nzValue]="pg.pge_grp_id" [nzLabel]="pg.pge_grp_nm">
          </nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item> -->
        <div class="input-row" nz-row>
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="mnuprflMrgn"
          >
            <nz-form-item>
              <nz-form-control>
                <div class="inptLbl">Page Name</div>
                <input
                  formControlName="pge_nm"
                  nz-input
                  placeholder="please enter page name"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="input-row" nz-row>
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="mnuprflMrgn"
          >
            <nz-form-item>
              <nz-form-control>
                <div class="inptLbl">Page Url</div>
                <input
                  formControlName="pge_url_tx"
                  nz-input
                  placeholder="please enter page url"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="input-row" nz-row>
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="mnuprflMrgn"
          >
            <nz-form-item>
              <nz-form-control>
                <div class="inptLbl">Page Description</div>
                <textarea
                  formControlName="pge_dscn_tx"
                  nz-input
                  placeholder="please enter page description"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="input-row" nz-row>
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="mnuprflMrgn"
          >
            <div class="inptLbl">Select Page Group</div>
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  required
                  nzPlaceHolder="Select Type"
                  formControlName="pge_grp_id"
                >
                  @for (pg of pagesLst; track pg) {
                  <nz-option
                    [nzValue]="pg.pge_grp_id"
                    [nzLabel]="pg.pge_grp_nm"
                  >
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div style="float: right">
          <button nz-button style="margin-right: 8px" (click)="closeSideBar()">
            Cancel
          </button>
          @if (!editClicked) {
          <button
            nz-button
            nzType="primary"
            (click)="submitpge()"
            [disabled]="!validatepgaeForm.valid"
          >
            Submit
          </button>
          } @if (editClicked) {
          <button
            nz-button
            nzType="primary"
            (click)="updatepge()"
            [disabled]="!validatepgaeForm.valid"
          >
            Save
          </button>
          }
        </div>
      </form>
    </nz-drawer>
  </div>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
